import { Users, ShieldCheck, ScrollText, AlertTriangle, Loader2 } from 'lucide-react';
import { useAdminSummary } from '@/features/admin/useAdmin';

export function SummaryTab() {
  const { data, isLoading } = useAdminSummary();

  if (isLoading || !data) {
    return (
      <div className="flex h-40 items-center justify-center text-xs" style={{ color: 'var(--text-muted)' }}>
        <Loader2 size={14} className="mr-2 animate-spin" /> Cargando metricas...
      </div>
    );
  }

  const cards = [
    { label: 'Usuarios totales', value: data.users_count, icon: Users, hint: `${data.users_active} activos` },
    { label: 'Roles definidos', value: data.roles_count, icon: ShieldCheck, hint: 'admin / engineer / viewer + custom' },
    { label: 'Eventos auditados', value: data.audit_count, icon: ScrollText, hint: 'todas las acciones registradas' },
    {
      label: 'Errores',
      value: data.audit_errors_count,
      icon: AlertTriangle,
      hint: 'logins fallidos y rechazos',
      tone: data.audit_errors_count > 0 ? 'warning' : 'ok',
    },
  ] as const;

  return (
    <div>
      <h2 className="mb-1 text-lg" style={{ fontFamily: 'var(--font-display)', fontWeight: 700 }}>
        Estado de la plataforma
      </h2>
      <p className="mb-6 text-xs" style={{ color: 'var(--text-muted)' }}>
        Vista rapida del estado actual. Refresca cada 30 segundos.
      </p>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
        {cards.map((c) => (
          <div
            key={c.label}
            className="rounded-[var(--radius-md)] border p-5"
            style={{ background: 'var(--surface-1)', borderColor: 'var(--border-default)' }}
          >
            <div className="mb-3 flex items-center justify-between">
              <span className="text-[10px] uppercase tracking-wider" style={{ color: 'var(--text-muted)' }}>
                {c.label}
              </span>
              <c.icon size={14} strokeWidth={1.6} style={{ color: 'tone' in c && c.tone === 'warning' ? 'var(--warning)' : 'var(--text-muted)' }} />
            </div>
            <div className="font-mono tabular text-3xl" style={{ color: 'tone' in c && c.tone === 'warning' ? 'var(--warning)' : 'var(--text-primary)', lineHeight: 1 }}>
              {c.value}
            </div>
            <div className="mt-2 text-[11px]" style={{ color: 'var(--text-muted)' }}>
              {c.hint}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
